import { menuItemKeys } from "../components/WheelCardThreeDotMenu/WheelCardThreeDotMenu";
import { WheelCategories } from "../components/WheelGallery/WheelListing/TabComponents/WheelsTab";
import RemoveFromFolderIcon from "../assets/icons/RemoveFromFolderIcon";
import { colors } from "./index";
import { ReactComponent as RemoveFolder } from "@assets/icons/wheelMenuIcons/remove-folder.svg";

export const getWheelMenuItems = (
  wheelCategory,
  data,
  isOthersGallery,
  isLoggedIn
) => {
  const isPrimary = data?.is_primary;
  const isLocked = data?.is_locked;
  switch (wheelCategory) {
    case WheelCategories.Created:
      return isOthersGallery
        ? [
            menuItemKeys.CLONE,
            isLocked ? menuItemKeys.UNLOCK : null,
            menuItemKeys.SHARE,
            menuItemKeys.FAVORITE,
            menuItemKeys.REPORT,
          ]
        : [
            menuItemKeys.EDIT,
            menuItemKeys.DELETE,
            menuItemKeys.DUPLICATE,
            isPrimary ? menuItemKeys.REMOVE_PRIMARY : menuItemKeys.PRIMARY,
            menuItemKeys.VISIBILITY,
            menuItemKeys.SHARE,
            menuItemKeys.MOVE,
          ];

    case WheelCategories.Cloned:
      return isOthersGallery
        ? [
            menuItemKeys.SHARE,
            isLocked ? menuItemKeys.UNLOCK : null,
            menuItemKeys.CLONE,
            menuItemKeys.FAVORITE,
            menuItemKeys.REPORT,
          ]
        : [
            menuItemKeys.EDIT,
            menuItemKeys.DELETE,
            isPrimary ? menuItemKeys.REMOVE_PRIMARY : menuItemKeys.PRIMARY,
            menuItemKeys.VISIBILITY,
            menuItemKeys.SHARE,
            menuItemKeys.MOVE,
          ];

    case WheelCategories.Favourited:
      return [menuItemKeys.SHARE, menuItemKeys.FAVORITE];

    case WheelCategories.Unlocked:
      return [
        menuItemKeys.SHARE,
        menuItemKeys.REPORT,
        // menuItemKeys.MOVE,
      ];

    default:
      return [menuItemKeys.SHARE];
  }
};

export const getRemoveFromFolderMenuItem = (handleRemoveAction) => ({
  key: "remove-from-folder",
  label: "Remove from Folder",
  icon: (
    <div>
      <RemoveFolder style={{ width: 15, height: 15 }} />
    </div>
  ),
  action: handleRemoveAction,
});
